module.exports = __webpack_public_path__ + "img/45_34.0420aabb.png";